import React from 'react';
import { Reveal } from './Reveal';
type Testimonial = {
  initials: string;
  quote: string;
  name: string;
  role: string;
};
const testimonials: Testimonial[] = [{
  initials: 'SR',
  quote: 'J’ai toujours su que quelque chose n’allait pas mais je ne pouvais pas le nommer. Les cartes de constellation ont tout rendu visible pour la première fois. J’ai pleuré pendant la moitié du Tome 2 — et c’était les meilleures larmes de ma vie.',
  name: 'Sophie R.',
  role: 'Paris, France · Auto-guérisseuse'
}, {
  initials: 'JT',
  quote: 'Le Bonus Génogramme de Solution à lui seul a complètement transformé ma relation avec l’argent. Je n’avais aucune idée que mes blocages financiers étaient enracinés dans la faillite de mon grand-père. Ce système voit ce que la thérapie avait manqué.',
  name: 'Jean-Marc T.',
  role: 'Lyon, France · Coach & Praticien'
}, {
  initials: 'MD',
  quote: 'Les ressources imprimables sont incomparables. J’ai les cartes de constellation sur le mur de mon cabinet. Mes clients me posent des questions à leur sujet à chaque séance. Cela vaut chaque centime et dix fois plus.',
  name: 'Marie-Laure D.',
  role: 'Bruxelles, Belgique · Thérapeute Holistique'
}];
export function TestimonialStrip() {
  return <section className="w-full bg-mist px-4 py-20 sm:py-24" data-id="element-229" data-mp="1vga4frrwojak">
      <div className="mx-auto max-w-6xl" data-id="element-230" data-mp="1vdxfgunqd8o0">
        <Reveal className="text-center" data-id="element-231" data-mp="296vqtqgkjbd7">
          <h2 className="font-serif text-4xl text-navy sm:text-5xl" data-id="element-232" data-mp="295u7kypefike">
            ⭐ Ce que les gens <span className="text-sage" data-id="element-233" data-mp="2551xy4cm7bnl">disent</span>
          </h2>
          <p className="mt-4 text-slate" data-id="element-234" data-mp="2j64iudrvifwx">
            Des personnes qui ont enfin compris leur histoire — et arrêté de vivre celle de quelqu’un d’autre.
          </p>
        </Reveal>
        <div className="mt-10 grid gap-5 md:grid-cols-3" data-id="element-235" data-mp="orbp6kajvz7m">
          {testimonials.map((item, index) => <Reveal key={item.initials} delay={index * 0.05} className="h-full" data-id="element-236" data-mp="jsqqipay5nla" data-mpi={index}>
              <figure className="flex h-full flex-col rounded-2xl border border-navy/10 bg-surface p-8 shadow-premium" data-id="element-237" data-mp="2juq7shlgd4uu">
                <div className="text-amber" data-id="element-238" data-mp="2otb9ymk9lylx">★★★★★</div>
                <blockquote className="mt-5 flex-1 text-[15px] leading-7 text-slate" data-id="element-239" data-mp="2ovxf6fjoo20z">«&nbsp;{item.quote}&nbsp;»</blockquote>
                <figcaption className="mt-7 flex items-center gap-3" data-id="element-240" data-mp="2xuhtl4i7npje">
                  <span className="flex h-11 w-11 items-center justify-center rounded-full bg-sage/15 text-sm font-bold text-sage" data-id="element-241" data-mp="2xvswz37quv9z">
                    {item.initials}
                  </span>
                  <span data-id="element-242" data-mp="37qukxvqa9raz">
                    <span className="block font-bold text-navy" data-id="element-243" data-mp="37qcighd12gum">{item.name}</span>
                    <span className="mt-0.5 block text-xs text-slate" data-id="element-244" data-mp="3clic62co8zt9">{item.role}</span>
                  </span>
                </figcaption>
              </figure>
            </Reveal>)}
        </div>
      </div>
    </section>;
}